import React, { useState, useEffect, useContext } from 'react'
import ConfigContext from '../../ConfigContext'
import { makeStyles } from '@material-ui/core/styles'
import axios from 'axios'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { setDialog } from '../../store/actions/dialog'

import { Grid, Box, Button, Paper, Typography, TextField } from '@material-ui/core'

import DefaultModal from '../atoms/DefaultModal'
import RightSideSubmitButton from '../molecules/RightSideSubmitButton'
import Dropzone from '../atoms/Dropzone'
import { formUploadHelper } from '../../helpers'

const useStyles = makeStyles(theme => ({
  uploadImage: {
    width: '80vw',
    height: '90vh',
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column'
  },
  previewImage: {
    width: '100px',
    objectFit: 'contain'
  },
  flexImageContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  flexImg: {
    width: '100px',
    objectFit: 'contain'
  }
}))

const ImageUpload: React.FC<
  ReturnType<typeof mapDispatchToProps> & {
    isOpen: boolean
    handleClose: () => void
    handleRefresh: () => Promise<void>
    handleUpdateNotification: (key: string) => void
  }
> = ({ isOpen, handleClose, handleRefresh, handleUpdateNotification, setDialog }) => {
  const classes = useStyles({})
  const [uploadedImages, setUploadedImages] = useState([])
  // s3対応
  // const [uploadedImages, setUploadedImages] = useState<{ preview: string; key: string }[]>([])
  const [file, setFile] = useState<File | null>(null)
  const [fileName, setFileName] = useState<string>('')
  const [preview, setPreview] = useState<string>('')
  const config = useContext(ConfigContext)

  const fetchData = async () => {
    const { data } = await axios.get<string[]>(`/upload/admin`)
    setUploadedImages(data)
    // s3対応
    // const images: { preview: string; key: string }[] = []
    // for (const row of data) {
    //   images.push({
    //     preview: `${config.serverHost}/upload/image/?key=${encodeURIComponent(row)}`,
    //     key: row
    //   })
    // }
    // setUploadedImages(images)
  }

  useEffect(() => {
    fetchData()
  }, [isOpen])

  const handleDrop = (files: File[]) => {
    setFile(files[0])
    setFileName(files[0].name)
    setPreview(URL.createObjectURL(files[0]))
  }

  const handleReset = () => {
    setFile(null)
    setFileName('')
    setPreview('')
  }

  const handleUpload = async () => {
    try {
      // アップロード
      await formUploadHelper(fileName, file, '/upload/admin', true)
      // フォームに入力していた内容をリセット
      handleReset()
      // アイコン一覧をもう一度取得
      fetchData()
      // 上の階層のコンポーネントの内容も再読み込み
      handleRefresh()
    } catch (error) {
      alert(error.message)
    }
  }

  const handleDelete = async (path: string) => {
    setDialog(
      '確認',
      '削除してもよろしいですか？',
      async () => {
        try {
          await axios.delete('/upload', {
            data: { path }
          })
          await axios.put(`/notifications/icon`, { path })
          fetchData()
          handleRefresh()
          handleUpdateNotification(path)
        } catch (error) {
          alert(error.message)
        }
      },
      () => {}
    )
  }

  return (
    <React.Fragment>
      <DefaultModal open={isOpen} onClose={() => handleClose()}>
        <Paper className={classes.uploadImage}>
          <Box height="50%">
            <Typography variant="subtitle2" paragraph>
              アイコンを追加
            </Typography>
            <Typography variant="body2" paragraph>
              【推奨サイズ】横：80px、縦：80px
            </Typography>
            <Box>
              <Dropzone
                dropHandler={files => handleDrop(files)}
                accept="image/jpeg, image/png, image/gif"
              />
            </Box>

            {file instanceof File && (
              <React.Fragment>
                <Box display="flex">
                  <Box mr={2}>
                    <img className={classes.previewImage} src={preview} alt="preview img" />
                  </Box>
                </Box>
                <RightSideSubmitButton
                  submittable={fileName.length > 0}
                  submitHandler={handleUpload}
                  resettable
                  resetHandler={() => handleReset()}
                />
              </React.Fragment>
            )}
          </Box>
          <Box height="50%">
            <Typography variant="subtitle2" paragraph>
              アイコンを削除
            </Typography>
            <Grid spacing={3} container alignItems="center">
              {uploadedImages.map((imagePath, index) => (
                <Grid item key={imagePath /* s3対応 imagePath.key */}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    className={classes.flexImageContainer}
                  >
                    <Box
                      width="120px"
                      height="120px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <img
                        className={classes.flexImg}
                        src={`${config.serverHost}${imagePath}` /* s3対応 imagePath.preview */}
                        alt={imagePath /* s3対応 imagePath.key*/}
                      ></img>
                    </Box>

                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => {
                        handleDelete(imagePath)
                        // s3対応
                        // handleDelete(imagePath.key)
                      }}
                    >
                      削除
                    </Button>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Paper>
      </DefaultModal>
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setDialog: (title: string, content: string, okHandler: () => void, ngHandler: () => void) =>
      dispatch(setDialog(title, content, okHandler, ngHandler))
  }
}
export default connect(null, mapDispatchToProps)(ImageUpload)
